import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Store from "core/store";
import { BrowserRouter } from "react-router-dom";
import { LoaderProvider } from './repositories/clients/LoaderContext'
import { initDebugOverlay } from './debugOverlay'

initDebugOverlay();

ReactDOM.render(
    <BrowserRouter>
        <Store>
            <LoaderProvider>
                <App />
            </LoaderProvider>
        </Store>
    </BrowserRouter>
    ,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();